import { createSlice } from "@reduxjs/toolkit";
import { loadEntitlements } from "./actions";

const initialState = {
  featureKeys: [],
  laneKeys: [],
  loaded: false,
  loading: false,
  error: null,
};

const entitlementsSlice = createSlice({
  name: "entitlements",
  initialState,
  reducers: {
    resetEntitlements: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadEntitlements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadEntitlements.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.featureKeys = action.payload.featureKeys || [];
        state.laneKeys = action.payload.laneKeys || [];
      })
      .addCase(loadEntitlements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || "Unknown error";
        // On error treat as "no entitlements loaded" — selectors return false.
        state.featureKeys = [];
        state.laneKeys = [];
        state.loaded = true; // mark loaded so callers don't spin forever
      });
  },
});

export const { resetEntitlements } = entitlementsSlice.actions;
export default entitlementsSlice.reducer;
